// extracted by mini-css-extract-plugin
export default {"y-split":"y-split--my3w1"};